import React from 'react';
import styles from '../css/cmapDetailsCSS.less';
import { Select } from 'antd';
import cx from 'classnames';
import DateFormat from '@/components/dateFormat';
import { BatchInfoVO } from '@/types/camp/campIndex/indexTypes';
import { getParame } from '@/pages/camp/util/indexUtil';
import { isEmpty } from 'lodash';
const { Option } = Select;

type BannerProps = {
  setBatchInfo: BatchInfoVO | null;
};

const BannerAdmin: React.FC<BannerProps> = ({ setBatchInfo }) => {
  const tabParame = getParame('tab');
  const formatTime = (srtTime: string, endTime: string) => {
    // 将字符串转换为Date对象
    let stTime = new Date(srtTime);
    let enTime = new Date(endTime);
    // 获取当前时间
    let currentTime = new Date();
    if (currentTime > stTime && currentTime < enTime) {
      return <DateFormat endTime={String(endTime)} endText="后结束" />;
    } else if (currentTime < stTime) {
      return <DateFormat endTime={String(stTime)} endText="后开始" />;
    }
  };

  const onChange = (value: string) => {
    window.location.href = `${value}?tab=${tabParame}`;
  };

  return (
    <>
      <div className={styles.cmap_banner} style={{ height: 180 }}>
        <div className={cx(styles.banner_warp, 'w1200 flex_3')} style={{ height: 180 }}>
          {setBatchInfo && !isEmpty(setBatchInfo.listBatch) && (
            <div className={cx(styles.lf, 'flex_2')}>
              <div className={styles.title}>{setBatchInfo?.camp.name}</div>
              <div className="flex_1">
                <div className="f20" style={{ marginRight: 24, marginTop: -4 }}>
                  <Select
                    showSearch
                    defaultValue={setBatchInfo.id}
                    optionFilterProp="label"
                    onChange={onChange}
                    style={{ minWidth: 200 }}
                  >
                    {setBatchInfo.listBatch.map((option) => (
                      <Option key={option.id} value={option.id} label={option.name}>
                        {option.name}
                      </Option>
                    ))}
                  </Select>
                </div>
                {formatTime(setBatchInfo?.stTime, setBatchInfo?.enTime)}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
export default BannerAdmin;
